<template>
  <v-card :href="href" class="fill-height" rounded="0">
    <ImageCover
      :image-key="imageKey"
      :value="value"
      default-key="person_default_image"
    >
      <v-chip
        v-if="value.is_featured"
        class="ma-2"
        color="red-darken-2"
        size="small"
        variant="flat"
        >Featured</v-chip
      >

      <v-btn
        v-if="href"
        :icon="mdiArrowRight"
        class="ma-2"
        color="primary"
        position="absolute"
        style="top: 0; right: 0"
      />
    </ImageCover>

    <v-card-text
      v-if="value.name || value.headline || value.title || value.summary"
    >
      <h3
        v-if="value.name"
        class="text-subtitle-2 text-primary text-uppercase text-center font-weight-bold"
      >
        {{ value.name }}
      </h3>

      <h5
        v-if="value.headline"
        class="text-subtitle-1 text-primary text-center"
      >
        {{ value.headline }}
      </h5>

      <h5 v-if="value.title" class="text-subtitle-1 text-primary text-center">
        {{ value.title }}
      </h5>

      <p
        v-if="value.summary"
        class="text-body-1 mt-2"
        style="line-height: 150%"
      >
        {{ value.summary }}
      </p>
    </v-card-text>

    <v-card-text
      v-if="value.paragraphs && value.paragraphs.length"
      class="text-body-1"
      style="line-height: 150%"
    >
      {{ value.paragraphs[0].paragraph_text }}
    </v-card-text>
  </v-card>
</template>

<script setup>
import { mdiArrowRight } from '@mdi/js'

defineProps({
  href: {
    default: undefined,
    type: String
  },
  imageKey: {
    default: 'profile_image',
    type: String
  },
  value: {
    required: true,
    type: Object
  }
})
</script>
